import * as React from "react";
import { SVGAttributes } from "react";

export const VisaIcon = React.memo(
  ({
    size = 24,
    color = "#4E5361",
    ...props
  }: SVGAttributes<SVGElement> & {
    size?: number,
  }) => {
    return (
      <svg width={size} height={size} fill="none" {...props}>
        <path
          d="M24.357.312l-3.092 18.141h4.944L29.304.312h-4.947zm-7.239.02l-4.842 12.372-.517-1.869c-.955-2.25-3.666-5.483-6.849-7.52l4.428 15.129 5.232-.01L22.356.329l-5.238.004z"
          fill="#8F8F8F"
        />
        <path
          d="M9.883 1.63C9.596.525 8.763.196 7.73.156H.064L0 .518c5.965 1.447 9.913 4.934 11.55 9.126L9.883 1.63zm29.44 2.16a9.128 9.128 0 013.7.694l.447.21.669-3.932C43.159.394 41.625 0 39.709 0c-4.885 0-8.329 2.46-8.355 5.987-.032 2.606 2.453 4.06 4.33 4.929 1.926.89 2.572 1.456 2.563 2.25-.015 1.215-1.536 1.772-2.956 1.772-1.98 0-3.032-.273-4.656-.95l-.637-.29-.695 4.06c1.157.508 3.292.944 5.508.967 5.198 0 8.575-2.431 8.61-6.2.022-2.06-1.296-3.634-4.154-4.924-1.73-.842-2.787-1.402-2.777-2.251 0-.754.898-1.56 2.833-1.56zM56.827.333h-3.82c-1.186 0-2.069.323-2.59 1.505l-7.341 16.626h5.192s.847-2.236 1.039-2.725l6.331.007c.148.634.603 2.718.603 2.718h4.587l-4-18.131zM50.73 12.026c.407-1.042 1.97-5.07 1.97-5.07-.027.05.403-1.05.658-1.732l.334 1.564 1.145 5.238H50.73z"
          fill="#8F8F8F"
        />
      </svg>
    );
  }
);
